<template>
  <div 
    class="main-content-title"
    style="max-width: 1400px; width: 100%; margin: 0 auto;"
  >
    <h2 style="font-size: 28px;">
      {{ $t("title.archives") }}
    </h2>
  </div>
  <div>
    <BoardList v-bind:tabs="tabs"/>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import BoardList from "./board/BoardList.vue";
import { storeToRefs } from "pinia";
import { useNoticesStore } from "@/store/notices";

export default defineComponent({
  name: "Archives",
  components: { BoardList },
  setup() {
    const route = useRoute();
    const noticesStore = useNoticesStore();
    const {
      noticeType,
      noticeDetailType,
      searchKeyword,
    } = storeToRefs(noticesStore);

    const tabs = ref([
      { noticeType: 2, noticeDetailType: 1, title: 'label.market_analysis'},
      { noticeType: 2, noticeDetailType: 2, title: 'label.education_information'},
      { noticeType: 2, noticeDetailType: 3, title: 'label.the_latest_drug_price'},
      { noticeType: 2, noticeDetailType: 4, title: 'label.manual'},
    ]);

    onMounted(() => {
      noticeType.value = 2;
      noticeDetailType.value = parseInt(route.query.noticeDetailType) || 1;
      searchKeyword.value = '';

      noticesStore.fetchNotices();
    });

    watch([noticeType, noticeDetailType], () => {
      noticesStore.fetchNotices();
    });

    return {
      tabs: tabs,
    };
  },
});
</script>